import { SubscriptionTier } from "@util/constants";
import { TIER_LABELS } from "@features/profile/PlanPage/lib/fullTierLabel";

import { IS_DEVELOPMENT } from "@util/deployEnv";

interface MavaIdentifyProperties {
  emailAddress: string;
  customAttributes: Array<{ label: string; value: unknown }>;
}

declare global {
  interface Window {
    Mava?: {
      initialize(): void;
      identify(properties: MavaIdentifyProperties): void;
    };
  }
}

if (IS_DEVELOPMENT) {
  // An extremely hacky way to silence Mava logs while they clean these up
  const originalLog = console.log;
  console.log = (...args) => {
    const err = new Error();

    if (err.stack?.includes("widget.mava.app")) return;

    originalLog(...args);
  };
}

export function identifyMavaUser(
  userId: number,
  values: {
    firstName: string;
    lastName: string;
    email: string;
    teamId?: number;
    teamName?: string;
    tier?: SubscriptionTier;
  },
  debug: boolean,
) {
  const Mava = window.Mava;
  if (typeof Mava === "undefined" || !Mava.identify || !Mava.initialize) {
    return;
  }

  if (debug) {
    console.debug("[Mava] identify", userId);
  }

  if (IS_DEVELOPMENT) {
    // Mava doesn't let you use localhost as an allowed host for sdk calls
    return console.log("[Mava] skipping identify in development environment.");
  }

  Mava.initialize();
  Mava.identify({
    emailAddress: values.email,
    customAttributes: [
      { label: "User ID", value: userId },
      ...(values.teamId ? [{ label: "Team ID", value: values.teamId }] : []),
      ...(values.teamName
        ? [{ label: "Team Name", value: values.teamName }]
        : []),
      {
        label: "Full Name",
        value: `${values.firstName || ""} ${values.lastName || ""}`.trim(),
      },
      ...(values.tier != null
        ? [{ label: "Customer Tier", value: TIER_LABELS[values.tier] }]
        : []),
    ],
  });
}
